import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Login from '@/components/Login'
import ForgotPassword from '@/components/ForgotPassword'
import Register from '@/components/Register'
import User from '@/components/User'
import Cart from '@/components/Cart'
import Order from '@/components/Order'
import PlaceList from '@/components/PlaceList'
import { mapActions } from 'vuex'
import LearningRecord from '@/components/LearningRecord'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: {
        mounted () {
          this.$store.dispatch('logout')
            .then(() => {
              this.$router.push('/')
            })
        }
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/forgot_password',
      name: 'Forgot Password',
      component: ForgotPassword,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      children: [
        { path: '', component: require('../components/MyProfile') },
        { path: 'profile', component: require('../components/MyProfile') },
        { path: 'password', component: require('../components/MyPassword') }
      ],
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/learning/record',
      name: 'Learning',
      component: LearningRecord
    },
    {
      path: '/order',
      name: 'Order',
      component: Order,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/event',
      name: 'Event',
      component: {
        template: '<router-view></router-view>'
      },
      children: [
        { path: '2018Summer', name: 'Event-2018Summer', component: require('../events/2018Summer') },
        { path: 'tibeSpecial2019', name: 'Event-tibeSpecial2019', component: require('../events/tibeSpecial2019') }
      ],
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/authorize/:token',
      name: 'Authorize',
      component: {
        mounted () {
          let self = this
          this.loginByToken({ 'token': this.$route.params.token })
            .then(() => {
              if (self.authorized) {
                self.$router.push('/')
              }
            })
        },
        methods: {
          ...mapActions([
            'loginByToken'
          ])
        }
      },
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/places',
      name: 'Places',
      component: PlaceList,
      meta: {
        requiresAuth: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js